import script from "./TestApi.vue?vue&type=script&setup=true&lang=js"
export * from "./TestApi.vue?vue&type=script&setup=true&lang=js"

import "./TestApi.vue?vue&type=style&index=0&id=472e287a&lang=css"

const __exports__ = script;

export default __exports__